// extracted by mini-css-extract-plugin
module.exports = {"root":"closeIcon_root__V1k9_ h-[18px] w-[18px] bg-no-repeat bg-cover"};